import { useEffect, type ReactNode } from 'react';

type Theme = 'light' | 'dark';

/**
 * Minimal theme provider: applies the `.dark` class on <html> (the app is dark-by-default).
 * A real user-facing toggle is a P1+ concern.
 */
export function ThemeProvider({
  children,
  defaultTheme = 'dark',
}: {
  children: ReactNode;
  defaultTheme?: Theme;
}) {
  useEffect(() => {
    document.documentElement.classList.toggle('dark', defaultTheme === 'dark');
  }, [defaultTheme]);

  return <>{children}</>;
}
